// extracted by mini-css-extract-plugin
module.exports = {"container":"GetUser_container__3fVEE","text":"GetUser_text__3BcDt","input":"GetUser_input__17IBW","button":"GetUser_button__MG-fy"};